import { SortingRule } from "react-table";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";

export interface INotifyAdminProps {
  changeLocation: (url: string) => {};
  notifications: ITableInfo;
  responseDelete: IResponseState;
  responseAddEditState: IResponseState;
  responseReplay: IResponseState;
  allRoles: string[];
  getNotifications: (body: INotifyCall, sortBy: SortingRule<{}>[]) => void;
  getAllRoles: () => void;
  deleteNotify: (id: string) => void;
  sendNotify: (data: INotifyGet) => void;
  updateNotify: (data: INotifyGet) => void;
  replayNotify: (data: INotifyGet) => void;
  loader: boolean;
}

export const NOTIFY_FORM_FILTER = "notificationManagementFormFilter";

export interface ITableInfo {
  pageNumber: number;
  totalElements: number;
  pageTotalNumber: number;
  pageSize: number;
  messages: INotify[];
}

export interface INotify {
  uniqueId?: string | number;
  title: string;
  message: string;
  startDate: number;
  roleList: string;
}

export interface INotifyDate {
  uniqueId?: string | number;
  title: string;
  message: string;
  startDate: string;
  roleList: string;
}

export interface INotifyGet {
  id?: string | number;
  title: string;
  message: string;
  startDate: number;
  roles: string[];
}

export interface INotifyCall {
  pageNumber: number;
  pageSize: number;
  title: string;
  message: string;
  date1: number;
  date2: number | Date | string;
}

export const TypeFilter = {
  idFilter: "id",
  titleFilter: "title",
  textFilter: "message",
  startDateFilter: "startDate",
  rolesFilter: "roleList",
};

export const STATE_IDENTIFIER = {
  NOTIFICATIONS: "notifications",
  NOTIFY_DEL_RESPONSE: "deleteResponse",
  NOTIFY_ADD_EDT_RESPONSE: "addEditResponse",
  NOTIFY_REPLAY_RESPONSE: "replayResponse",
  LOADER_IDENTIFIER: "loader",
  ALL_ROLES: "allRoles",
};
